import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.bundle.min.js';
import "@fontsource/open-sans";
import React from "react";
import ScrollTop from "./src/components/ScrollTop/ScrollTop";
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

if (typeof window !== "undefined") {
  gsap.registerPlugin(ScrollTrigger);
}

// Controla a posição do scroll na troca de rota
export const shouldUpdateScroll = ({ routerProps: { location }, getSavedScrollPosition }) => {
  // REMOVIDO: ScrollTrigger.getAll().forEach(...) -> Isso estava quebrando os novos elementos
  
  if (location.action === "PUSH") {
    // Força o topo em novas navegações
    window.scrollTo(0, 0);
  } else {
    // Mantém a posição se for botão "Voltar"
    const savedPosition = getSavedScrollPosition(location);
    window.scrollTo(...(savedPosition || [0, 0]));
  }
  return false;
};

// Executado quando a nova rota termina de carregar
export const onRouteUpdate = () => {
  // Apenas recalcula as posições, sem matar as animações
  ScrollTrigger.refresh();

  // Loader do Mailchimp
  setTimeout(() => {
    if (window.dojo) {
      try {
        window.dojo.require("mojo/signup-forms/Loader").start();
      } catch (err) {
        console.error("Erro ao carregar Mailchimp:", err);
      }
    }
  }, 1000);
};

export const wrapPageElement = ({ element }) => {
  return (
    <>
      <ScrollTop />
      {element}
    </>
  );
};